window.handlers = {
  showTimeoutId: undefined,
  hideTimeoutId: undefined,
  toggleOverlay: function(e) {
    const selectors = {
      body: 'body',
      overlay: '.product-overlay',
      activePopUpContent: '.popup--active',

      overflow: 'overflow-hidden',
      overlayActiveClass: 'product-overlay--active',
      popUpActiveClass: 'popup--active',
    };
    const body = document.querySelector(selectors.body);
    const overlay = document.querySelector(selectors.overlay);
    const activePopUpContent = document.querySelector(selectors.activePopUpContent);

    body.classList.toggle(selectors.overflow);
    overlay.classList.toggle(selectors.overlayActiveClass);

    if (e && e.target.classList.contains('product-overlay')) {
      activePopUpContent.classList.remove(selectors.popUpActiveClass);
    }
  },
  addProduct: async function(id, quantity = 1, preOrderValue) {
    const selectors = {
      confirmationPopup: '.confirmation-popup',
      confirmationImage: '.confirmation-popup__item-details-image',
      confirmationTitle: '.confirmation-popup__item-details-name',
      errorPopup: '.error-popup',
      cartDrawer: 'cart-drawer',
      cartDrawerCount: '.drawer__items-count span',
      headerCartCount: '.header__cart-value',
      recipientCheckbox: '.recipient-checkbox',
      giftInput: '.recipient-form .gift-card-recipient__input-data',
      errorPopupDescription: '.error-popup__description',

      confirmationPopupActiveClass: 'confirmation-popup--active',
      errorPopupActiveClass: 'error-popup--active',
      headerCountHideClass: 'header__cart-value--hidden',
    };
    const confirmationPopup = document.querySelector(selectors.confirmationPopup);
    const errorPopup = document.querySelector(selectors.errorPopup);
    const confirmationPopupDelay = confirmationPopup.dataset.closeTime;
    const closePopupDelay = errorPopup.dataset.closeTime;
    const recipientCheckbox = document.querySelector(selectors.recipientCheckbox);
    const properties = {};

    try {
      confirmationPopup.classList.remove(selectors.confirmationPopupActiveClass);

      if (recipientCheckbox && recipientCheckbox.checked) {
        const giftInputs = document.querySelectorAll(selectors.giftInput);
        const propertiesCheck = {};

        giftInputs.forEach((input) => {
          propertiesCheck[input.name] = input.value;
        });

        const checkPropertyResult = (props) => {
          const errors = {};

          if (!props['Recipient name']) {
            errors['name'] = ["Please enter recipient name"];
          }

          if (!props['Recipient email']) {
            errors['email'] = ["Please enter recipient email address"];
          }

          if (!props['Send on']) {
            errors['send_on'] = ["Please choose send date within next 90 days"];
          }

          return errors;
        };

        const validationResult = checkPropertyResult(propertiesCheck);

        if (Object.keys(validationResult).length > 0) {
          const errorDescriptions = {};
          const errorMessages = [];

          for (const key in validationResult) {
            if (validationResult.hasOwnProperty(key)) {
              errorDescriptions[key] = validationResult[key];
              errorMessages.push(`${key.charAt(0).toUpperCase() + key.slice(1)} ${validationResult[key]}`);
            }
          }

          const errorDetail = {
            responseJSON: {
              status: 422,
              description: errorDescriptions,
              errors: errorDescriptions,
              message: "Validation failed: " + errorMessages.join(', ')
            }
          };

          if (window.isGiftFormErros) {
            window.isGiftFormErros(errorDetail);
          }

          return null;
        } else {
          const giftInputs = document.querySelectorAll(selectors.giftInput);

          giftInputs.forEach((input) => {
            properties[input.name] = input.value;
          });
        }
      }

      if (preOrderValue) {
        properties['_dueDateValue'] = preOrderValue;
      }

      const data = {
        items: [
          {
            id: id,
            quantity: quantity,
            properties
          }
        ],
        sections: selectors.cartDrawer
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorData = await response.json();

        const errorDetail = {
          responseJSON: {
            status: 422,
            description: errorData.description,
            errors: errorData.errors,
          }
        };

        if (window.isGiftFormErros) {
          window.isGiftFormErros(errorDetail);
        }

        throw errorData.message;
      }

      const result = await response.json();
      const cartDrawer = new DOMParser().parseFromString(result.sections[selectors.cartDrawer], 'text/html');
      const drawerItemsList = document.querySelector(selectors.cartDrawer);
      const responseDrawerItemsList = cartDrawer.querySelector(selectors.cartDrawer);
      const currentProduct = result.items[0];
      const currentTitle = currentProduct.title.split(' / ');
      const confirmationImage = document.querySelector(selectors.confirmationImage);
      const confirmationTitle = document.querySelector(selectors.confirmationTitle);
      const cartDrawerCount = cartDrawer.querySelector(selectors.cartDrawerCount);
      const headerCartCount = document.querySelector(selectors.headerCartCount);
      const clearAllTimeouts = () => {
        if (this.showTimeoutId) clearTimeout(this.showTimeoutId);
        if (this.hideTimeoutId) clearTimeout(this.hideTimeoutId);
      };

      clearAllTimeouts();

      confirmationTitle.innerText = currentTitle[0];

      const tempImage = new Image();

      tempImage.src = currentProduct.image + '&width=100';
      tempImage.onload = () => {
        confirmationImage.src = currentProduct.image + '&width=100';

        this.showTimeoutId = setTimeout(() => {
          confirmationPopup.classList.add(selectors.confirmationPopupActiveClass);
        }, 100);

        this.hideTimeoutId = setTimeout(() => {
          confirmationPopup.classList.remove(selectors.confirmationPopupActiveClass);
        }, +confirmationPopupDelay);
      };

      errorPopup.classList.remove(selectors.errorPopupActiveClass);
      drawerItemsList.outerHTML = responseDrawerItemsList.outerHTML;
      headerCartCount.innerText = cartDrawerCount.innerText;

      if (+cartDrawerCount.innerText === 0) {
        headerCartCount.classList.add(selectors.headerCountHideClass);
      } else {
        headerCartCount.classList.remove(selectors.headerCountHideClass);
      }

      if (recipientCheckbox && recipientCheckbox.checked) {
        recipientCheckbox.click();
      }
    } catch (error) {
      const errorPopupDescription = document.querySelector(selectors.errorPopupDescription);

      errorPopupDescription.innerHTML = error;
      errorPopup.classList.add(selectors.errorPopupActiveClass);

      setTimeout(() => {
        errorPopup.classList.remove(selectors.errorPopupActiveClass);
      }, +closePopupDelay);
    }
  },
  initHandlers: function() {
    const selectors = {
      toggleHandler: '.js-toggle-overlay',
    };
    const toggleHandler = document.querySelector(selectors.toggleHandler);

    toggleHandler?.addEventListener('click', (e) => {
      window.handlers.toggleOverlay(e);
    });
  }
};

window.handlers['initHandlers']();
